import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import axios from './axios';
import i18n from './i18n';
import FormDropdown from '@/components/common/FormDropdown.vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css'
import './toast-multiline.css'
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {getImageUrl, getRowImageUrl} from "@/utils";


const app = createApp(App);

window.dt_opts = {
    "bFilter": true,
    "sDom": 'fBtlpi',  
    "ordering": false,
    "language": {
        search: ' ',
        sLengthMenu: '_MENU_',
        searchPlaceholder: "Search",
        info: "_START_ - _END_ of _TOTAL_ items",
        paginate: {
            next: ' <i class=" fa fa-angle-right"></i>',
            previous: '<i class="fa fa-angle-left"></i> '
        },
     },
    initComplete: (settings, json)=>{
        $('.dataTables_filter').appendTo('#tableSearch');
        $('.dataTables_filter').appendTo('.search-input');

    },	
}

const options = {
    position: 'top-right',
    timeout: 3000,
    closeOnClick: true,
    pauseOnHover: true,
}

app.use(Toast, options);
app.use(router);
app.use(i18n);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$API_BASE_URL = window.API_BASE_URL;

app.config.globalProperties.$getImageUrl = getImageUrl;
app.config.globalProperties.$getRowImageUrl = getRowImageUrl;

app.component('FormDropdown', FormDropdown);
app.component('VueDatePicker', VueDatePicker);
app.mount('#app');

